import * as ng from 'angular';

export class MoleculeButtonAddController implements ng.IController {
    public static $inject: string[] = [];
    public callbackParam: any;

    public add: (index?: number) => void;
    public disabled: boolean;

    public buttonName: string;

    public triggerAddCallback = () => {
        if (this.callbackParam !== undefined) {
            this.add(this.callbackParam);
        } else {
            this.add();
        }
    };

    public getName(): string {
        let result = "";
        if ( this.buttonName != undefined ) {
            result += "-" + this.buttonName;
        }
        return result;
    }
}

export class MoleculeButtonAddComponent implements ng.IComponentOptions {
    public transclude = true;
    public bindings = {
        add: '<',
        callbackParam: '<?',
        disabled: '<',
        buttonName: '@?'
    };
    public controller =  MoleculeButtonAddController;
    public template = require('./button-add.html');
}
